import { z } from "zod";
import { defineWidget } from "@/lib/home/widget";

/** Time and date, with an optional second time zone. */
export default defineWidget({
  type: "kourai.clock",
  version: 1,
  title: "Clock",
  description: "The time here and in one other place",
  sizes: ["s", "m"],
  defaultSize: "s",
  surfaces: ["newtab", "sidepanel"],
  data: "none",
  permissions: [],
  config: z.object({
    /** An IANA zone ("America/New_York"), or empty for none. */
    secondZone: z.string().max(64).default(""),
  }),
  load: () => import("./clock-widget"),
});
